module.exports = __webpack_public_path__ + "img/voice-icon10.691d52d.png";